module.exports = __webpack_public_path__ + "img/蒙版组 5.d27b7a42.png";